// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__161N2","location":"Header_location__3Hqw6"};